import { ContextMenuItem } from "@/components/ui/context-menu";

interface Props extends React.ComponentProps<"div"> {
  rightClickedElement: HTMLElement;
}

const RemoveIcon: React.FC<Props> = ({ rightClickedElement }) => {
  const removeIcon = () => {
    const iconWrapper = rightClickedElement.closest(
      '[contenteditable="false"]'
    ) as HTMLElement | null;

    const targetElement = iconWrapper || rightClickedElement;
    const trailing = targetElement.nextSibling;

    targetElement.remove();

    if (trailing && trailing.nodeName === "BR" && trailing.parentElement) {
      trailing.parentElement.removeChild(trailing);
    }
  };

  return (
    <ContextMenuItem className="text-red-500" onClick={removeIcon}>
      حذف آیکون
    </ContextMenuItem>
  );
};

export default RemoveIcon;
